import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Invoicerecordpayment from "../Invoicerecordpayment";

function AdminInvoiceRecordPayment(){
    const[searchUi,setSearchUi]=useState(false)
    const[searchContent,setSearchContent]=useState('')
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={4}
        childrenPage={<Invoicerecordpayment/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoiceRecordPayment;